module.exports = __webpack_public_path__ + "static/img/fireWater_active.35146af1.png";